import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const UselessProducts = lazyWithPreload(
  () => import('./UselessProducts'),
)
